import { getRatio, pxtorem } from "@/utils/pxtorem";
import React from "react";
import BackView from "../BackView";
import styles from "./index.module.less";


// 榜单头部内容组件（两侧枝条+中间榜单名称）
const NavHeader4App: React.FC<{ 
  rankName?: string;
  statusBarHeight?: number;
  isTabSticky?: boolean;
}> = ({
  rankName = "热卖榜单",
  statusBarHeight = 50,
  isTabSticky = false
}) => {
    return (
      <>
        <BackView statusBarHeight={statusBarHeight} imgSrc="https://akim-oss.aikucun.com/b07f427927175d0e745611f0d4342969f9f468f3_1703228563129_65.png"/>
        {isTabSticky && (
          <div className={styles.appStickyHeader} style={{ 
            height: (44 + statusBarHeight) * getRatio(),
            paddingTop: statusBarHeight * getRatio(),
            }}>
            {rankName}
          </div>
        )}
      </>
    );
  };

export default NavHeader4App;